import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PROJECT_LIST } from '../constants/projects';
import BoxContentOne from '../Content/boxcontentone';
import PaginationDiv from './PaginationDiv';
import './Project.css';

const PROJECTS_PER_PAGE = 6;

const Project = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(PROJECT_LIST.length / PROJECTS_PER_PAGE);

  const indexOfLastProject = currentPage * PROJECTS_PER_PAGE;
  const indexOfFirstProject = indexOfLastProject - PROJECTS_PER_PAGE;
  const currentProjects = PROJECT_LIST.slice(indexOfFirstProject, indexOfLastProject);

  return (
    <>
      <BoxContentOne />
      <div className="project-container">
        <h2>Our Latest Projects</h2>
        <div className="project-Con">
          <div className="project-grid">
            {currentProjects.map((project) => (
              <div key={project.id} className="project-card">
                <Link to={project.url}>
                  <img src={project.img} alt={project.title} />
                  <div className="project-body">
                    <h5 className="project-title">{project.title}</h5>
                    <p className="project-description">{project.description}</p>
                    <span className="btn">More info</span>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
        <PaginationDiv
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      </div>
    </>
  );
};

export default Project;
